<div class="panel panel-default col-sm-5" style="margin-left: 100px; display: none" id="settingsPasswordPolicy">
  <div class="panel-heading">Password Policy</div>

  <div class="panel-body">

    <form class="form-horizontal">
      <div class="form-group">
        <div class="col-sm-12"><h6>MINIMUM REQUIREMENT</h6></div>
        <label class="control-label col-sm-3">Uppercase Letters</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="min_upper" [(ngModel)]="min_upper"></div>
        <label class="control-label col-sm-4">Length (Total Characters</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="min_length" [(ngModel)]="min_length"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">Lowercase Letters</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="min_lower" [(ngModel)]="min_lower"></div>
        <label class="control-label col-sm-4">Spaces Permitted (Y/N)</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="allow_whitespace" [checked]="allow_whitespace" (click)="allowWhitespaceClicked()" class="styled"><label for="space"></label></div></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">Numerals</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="min_numeric" [(ngModel)]="min_numeric"></div>
        <label class="control-label col-sm-4">Passwords To Remember</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="duplicates" [(ngModel)]="duplicates"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">Letters</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="min_alpha" [(ngModel)]="min_alpha"></div>
        <label class="control-label col-sm-4">Days Valid Before Change Required</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="expire" [(ngModel)]="expire"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">Special Symbols</label>
        <div class="col-sm-2"><input class="form-control" type="text" name="min_special" [(ngModel)]="min_special"></div>
      </div>

         <div class="modal-footer">
            <button class="btn btn-primary" (click)="updateSettingsPassword()"><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE</button>
         </div>

    </form>
  </div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
